import { getInstance } from "@/auth/";
import api from "@/api";
import apiV2 from "@/apiV2";

export default {
  namespaced: true,
  state: {
    currentUser: "loading",
    currentUserData: {},
    linkingAccount: false
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setCurrentUserData(state, user) {
      state.currentUserData = user;
      localStorage.setItem("currentUserData", JSON.stringify(user.data));
    },
    setLinkingAccount(state, payload) {
      state.linkingAccount = payload;
    }
  },
  actions: {
    initAuth({ commit, dispatch, state }) {
      // Getting current Auth Instance
      const authService = getInstance();
      // If Authservice is finished loading and is authenticated then get Token and Init Auth
      if (!authService.loading) {
        if (authService.isAuthenticated && !state.linkingAccount) {
          authService.getIdTokenClaims().then(res => {
            api.defaults.headers.Authorization = `Bearer ${res.__raw}`;
            apiV2.defaults.headers.Authorization = `Bearer ${res.__raw}`;
            commit("setCurrentUser", authService.user);
            dispatch("loadCurrentUserData");
          });
        } else {
          dispatch("logout", state.currentUser != null);
          authService.$watch("isAuthenticated", () => {
            dispatch("initAuth");
          });
        }
        setTimeout(() => {
          dispatch("settings/setFullLoaderState", false, { root: true });
        }, 500);
      } else {
        // Else wait till finish loading and add a listener for "isAuthenticated"
        authService.$watch("loading", loading => {
          if (loading === false) {
            dispatch("initAuth");
            authService.$watch("isAuthenticated", () => {
              dispatch("initAuth");
            });
          }
        });
      }
    },
    async loadCurrentUserData({ commit, rootState, dispatch }) {
      // commit("setCurrentUserData", { Result: "Loading" });
      let userData = await api.get("user/CurrentUserData/auth0");
      commit("setCurrentUserData", userData.data);
      if (userData.data.Result == "Denied") {
        dispatch("logout");
      }
    },
    async logout({ commit }, withRedirect = true) {
      commit("setLinkingAccount", false);
      if (withRedirect) {
        const authService = getInstance();
        authService.logout({
          returnTo: window.location.origin
        });
      }

      commit("setCurrentUser", null);
    },
    async impersonate({ commit, dispatch }, payload) {
      let userData = await api.post("user/impersonate", payload);
      commit("setCurrentUserData", userData.data);
      if (userData.data.Result == "Denied") {
        dispatch("impersonateStop");
      }
    },
    async impersonateStop({ commit, dispatch }) {
      let userData = await api.post("user/impersonate/stop");
      commit("setCurrentUserData", userData.data);
      if (userData.data.Result == "Denied") {
        dispatch("impersonateStop");
      }
    },
    async linkWithGoogle({ commit, state, dispatch }) {
      commit("setLinkingAccount", true);
      const authService = getInstance();
      const { sub } = await authService.getUser();

      await authService.loginWithPopup({
        connection: "google-oauth2"
      });
      const secondary = await authService.getUser();
      await api.post(`users/linkWithGoogle`, {
        sub: sub,
        provider: "google-oauth2",
        secondarySub: secondary.sub
      });
      commit("setLinkingAccount", false);
      dispatch("initAuth");
    }
  },
  getters: {
    currentUser(state) {
      return state.currentUser;
    },

    currentUserData(state) {
      return state.currentUserData;
    }
  }
};
